import {UAParser} from 'ua-parser-js'

interface NavigatorUABrand {
  brand: string;
  version: string;
}

interface NavigatorUAData {
  brands: NavigatorUABrand[];
  mobile: boolean;
  getHighEntropyValues(hints: string[]): Promise<{
    architecture?: string;
    model?: string;
    platform?: string;
    platformVersion?: string;
    uaFullVersion?: string;
    fullVersionList?: NavigatorUABrand[];
  }>;
}

declare global {
  interface Navigator {
    userAgentData?: NavigatorUAData;
  }
}

export interface FilePickerAcceptType {
    description?: string;
    accept: Record<string, string | string[]>;
  }
  
export interface ShowSaveFilePickerOptions {
    suggestedName?: string;
    types?: FilePickerAcceptType[];
    excludeAcceptAllOption?: boolean;
  }
  
  // Define the structure for the file handle
export interface FileSystemFileHandle {
    readonly kind: 'file';
    readonly name: string;
    createWritable(options?: { keepExistingData?: boolean }): Promise<FileSystemWritableFileStream>;
    // Add other methods like getFile() if needed
  }
  
  // Define the structure for the writable stream
export interface FileSystemWritableFileStream extends WritableStream {
    write(data: BufferSource | Blob | string): Promise<void>;
    seek(position: number): Promise<void>;
    truncate(size: number): Promise<void>;
    close(): Promise<void>; // Ensure close is defined
}

const L = console.log
const E = console.error

export class AppEnv {
/**
 * EXTRACT detail of application's system environment
 * @returns 
 */
  static async system () : Promise<Record<string,string>|undefined> {
    try {
      const parser = new UAParser()
      const $browser = await parser.getBrowser()
      const $os = await parser.getOS().withClientHints()
      const $device = await parser.getDevice().withClientHints()
      const $cpu = await parser.getCPU().withClientHints()
      const $wh = window['wh']?.env ? await window['wh']?.env() : null

      const nz = _ => _ ?? 'UNKNOWN'

      const browser = {
          name: nz($browser.name),
          version: nz($browser.version),
      }
      const os = {
          name: nz($os.name),
          version: nz($os.version),
          arch: nz($cpu.architecture),
      }
      const device = {
          model: nz($device.model),
          vendor: nz($device.vendor),
      }

      // OBTAIN FULL browser version (if available)
      if (typeof navigator !== 'undefined' && navigator.userAgentData) {
        const data = await navigator.userAgentData.getHighEntropyValues([ 'uaFullVersion' ])
        browser.version = data.uaFullVersion ?? browser.version
      }

      const info:any = {
          browser: `${browser.name} ${browser.version}`,
          os: `${os.name} ${os.version} ${os.arch}`,
          device: `${device.vendor} ${device.model}`,
      }
      if ($wh?.version) {
        info.wolffhound = $wh.version
      }
      return info
    } catch (e) {
      E('APPENV.system ERROR:',e)
    }
  }
}
